/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';

/**
 * 
 * @export
 * @interface WebApiViewDtoCreateViewColumnDto
 */
export interface WebApiViewDtoCreateViewColumnDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiViewDtoCreateViewColumnDto
     */
    sortOrder: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiViewDtoCreateViewColumnDto
     */
    columnType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {number}
     * @memberof WebApiViewDtoCreateViewColumnDto
     */
    customFieldId?: number | null;
}

/**
 * Check if a given object implements the WebApiViewDtoCreateViewColumnDto interface.
 */
export function instanceOfWebApiViewDtoCreateViewColumnDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sortOrder" in value;

    return isInstance;
}

export function WebApiViewDtoCreateViewColumnDtoFromJSON(json: any): WebApiViewDtoCreateViewColumnDto {
    return WebApiViewDtoCreateViewColumnDtoFromJSONTyped(json, false);
}

export function WebApiViewDtoCreateViewColumnDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiViewDtoCreateViewColumnDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sortOrder': json['sortOrder'],
        'columnType': !exists(json, 'columnType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['columnType']),
        'customFieldId': !exists(json, 'customFieldId') ? undefined : json['customFieldId'],
    };
}

export function WebApiViewDtoCreateViewColumnDtoToJSON(value?: WebApiViewDtoCreateViewColumnDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sortOrder': value.sortOrder,
        'columnType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.columnType),
        'customFieldId': value.customFieldId,
    };
}

